import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ClientAccountComponent } from './client-account.component';


const routes: Routes = [
  {
    path: '',
    component: ClientAccountComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ClientAccountRoutingModule { }
